<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import singleInputField from 'multisite/components/formElements/singleInputField.vue';
import phoneInputField from 'multisite/components/formElements/phoneInputField.vue';
import selectField from 'multisite/components/formElements/selectField.vue';
import countryField from 'multisite/components/formElements/countryField.vue';
import twoInputFieldsLine from 'multisite/components/formElements/twoInputFieldsLine/twoInputFieldsLine.vue';

const store = useStore();
const props = defineProps({
	formFields: Array,
	formData: Object,
	errors: Object,
	updateFieldError: Function,
	formState: Object,
	addressType: {
		validator(value) {
			return ['shippingAddress', 'mailingAddress', 'otherAddress'].includes(value);
		},
		default: 'shippingAddress',
	},
});

defineEmits(['update-form']);

const isUserLoggedIn = computed(() => store.getters['getIsUserLoggedIn']);
const componentMap = {
	singleInputField,
	phoneInputField,
	selectField,
	countryField,
	twoInputFieldsLine,
};
const isFieldHidden = (fieldName) => fieldName === 'deliveryInstruction1' && props.formData?.deliveryInstruction?.toLowerCase() !== 'none';

const isFieldReadOnly = (fieldName) => {
	if (!isUserLoggedIn.value) return false;

	let readOnlyFields = ['email'];

	return readOnlyFields.includes(fieldName);
};
</script>

<template>
	<div
		v-for="field in formFields"
		:key="field.data.fieldId"
		:class="{
			'name-field first': field.data.fieldName === 'firstName',
			'name-field': field.data.fieldName === 'lastName',
		}"
	>
		<component
			class="form-field"
			v-if="field.data.fieldName && !isFieldHidden(field.data.fieldName)"
			v-bind="field.data"
			:is="componentMap[field.fieldType]"
			:model-value="formData[field.data.fieldName]"
			:read-only="isFieldReadOnly(field.data.fieldName)"
			@update:model-value="
				$emit('update-form', {
					fieldName: field.data.fieldName,
					value: $event,
				})
			"
			:errors="errors"
			:updateFieldError="updateFieldError"
			:submitted="formState.submitted || null"
			:data-field-name="field.data.fieldName"
			:address-type="addressType"
		/>
		<component
			v-else-if="!isFieldHidden(field.data.fieldName)"
			v-bind="field.data"
			:read-only="isFieldReadOnly(field.data.rightFieldName)"
			:is="componentMap[field.fieldType]"
			:formData="formData"
			:errors="errors"
			:updateFieldError="updateFieldError"
			:submitted="formState.submitted || null"
			:address-type="addressType"
		/>
	</div>
</template>
